import {
  Table as MuiTable,
  TableProps as MuiTableProps,
  TableHead as MuiTableHead,
  TableHeadProps,
  TableBody as MuiTableBody,
  TableBodyProps,
  TableRow as MuiTableRow,
  TableRowProps,
  TableCell as MuiTableCell,
  TableCellProps,
  TableContainer as MuiTableContainer,
  TableContainerProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { tokens } from '../../theme/styles/themeMui';

export type TableProps = MuiTableProps;
export type { TableContainerProps, TableHeadProps, TableBodyProps, TableRowProps, TableCellProps };

export const TableContainer = styled(MuiTableContainer)<TableContainerProps>(() => ({}));

export const Table = styled(MuiTable)<MuiTableProps>(() => ({
  width: '100%',
  borderCollapse: 'collapse',
}));

export const TableHead = styled(MuiTableHead)<TableHeadProps>(() => ({}));

export const TableBody = styled(MuiTableBody)<TableBodyProps>(() => ({}));

export const TableRow = styled(MuiTableRow)<TableRowProps>(({ theme }) => ({
  backgroundColor: theme.palette.colors.special.nulled,
  '&:hover': {
    backgroundColor: theme.palette.colors.bg['active-neutral-secondary'],
  },
}));

export const TableHeaderCell = styled(MuiTableCell)<TableCellProps>(({ theme, align }) => ({
  padding: '8px 12px',
  height: '48px',
  textAlign: align || 'left',
  ...tokens.typography['body-s-compact-accent'],
  color: theme.palette.colors.content.primary,
  borderBottom: `1px solid ${theme.palette.colors.border.separator}`,
}));

interface ExtendedTableCellProps extends TableCellProps {
  truncate?: boolean;
}

export const TableCell = styled(MuiTableCell, {
  shouldForwardProp: (prop) => prop !== 'truncate',
})<ExtendedTableCellProps>(({ theme, align, truncate }) => ({
  padding: '8px 12px',
  minHeight: '40px',
  borderBottom: `1px solid ${theme.palette.colors.border.separator}`,
  verticalAlign: 'middle',
  textAlign: align || 'left',
  ...tokens.typography['body-s-regular'],
  color: theme.palette.colors.content.primary,
  ...(truncate && {
    maxWidth: 0,
    overflow: 'hidden',
  }),
}));
